import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type Flow from 'invite-sign/models/flow';

export default class PhotoPage extends Model {
  declare [Type]: 'photo-page';

  @belongsTo('flow', { async: false, inverse: 'photoPage' }) declare flow: Flow;

  @attr('boolean') declare enabled: boolean;
  @attr('boolean') declare useExistingPhoto: boolean;
}
